import { fetchDataPromise } from '../index';

export const getNotifySettings = (resolve, reject, token, site) => {
    let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['settings'] + '/getnotifyInfo', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Authorization' : token,
        'Content-Type' : 'application/json'
      },
      body: JSON.stringify({
        site: site
      })
    });
  
    fetchDataPromise(req, 'getNotifyDetail', resolve, reject);
}

export const saveNotifySettings = (resolve, reject, token, site, notifyObj) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['settings'] + '/savenotifyInfo', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      id: notifyObj.id,
      smtpHost: notifyObj.smtpHost,
      smtpAccount: notifyObj.smtpAccount,
      smtpPwd: notifyObj.smtpPwd,
      smtpPort: notifyObj.smtpPort,
      emailFrom: notifyObj.emailFrom,
      emailAlias: notifyObj.emailAlias,
      site: site,
    })
  });

  fetchDataPromise(req, 'getNotifyDetail', resolve, reject);
}

export const testSMTPEmail = (resolve, reject, token, account, notifyObj) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['settings'] + '/testsmtp', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      account: account,
      smtpHost: notifyObj.smtpHost,
      smtpAccount: notifyObj.smtpAccount,
      smtpPwd: notifyObj.smtpPwd,
      smtpPort: notifyObj.smtpPort,
      emailFrom: notifyObj.emailFrom,
      emailAlias: notifyObj.emailAlias,
    })
  });

  fetchDataPromise(req, 'testsmtp', resolve, reject);
}